module.exports = __webpack_public_path__ + "img/bikehall.065659a8.jpg";